export const ADMIN = '1';
export const PMF_NASTAVNIK = '2';
export const SKOLA = '3';
export const DMS = '11'; // TODOOOOOO

export const nameAdmin = 'ADMIN';
export const namePMF = 'PMF NASTAVNIK';
export const nameSkola = 'ŠKOLA';
